export default "__VITE_ASSET__DTBevqXR__"